import * as React from 'react';
import { IgcCheckboxComponent as Component } from 'igniteui-webcomponents';
import type { IgcCheckboxComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * A check box allowing single values to be selected/deselected.
 * @slot  - The checkbox label.
 * @slot helper-text - Renders content below the input.
 * @slot value-missing - Renders content when the required validation fails.
 * @slot custom-error - Renders content when setCustomValidity(message) is set.
 * @slot invalid - Renders content when the component is in invalid state (validity.valid = false).
 * @fires igcChange - Emitted when the control's checked state changes.
 * @csspart base - The base wrapper of the checkbox.
 * @csspart control - The checkbox input element.
 * @csspart label - The checkbox label.
 * @csspart indicator - The checkbox indicator icon.
 * @class
 */
export const IgrCheckbox = /* @__PURE__ */ createComponent({
  tagName: 'igc-checkbox',
  displayName: 'IgrCheckbox',
  elementClass: Component,
  react: React,
  events: {
    onChange: 'igcChange' as EventName<
      IgcCheckboxComponentEventMap['igcChange']
    >,
  },
});

export type IgrCheckbox = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCheckboxModule = Component;
